import * as BiojsUtil from 'biojs/Util';
import areAminoAcidsValid from 'molbio/aa-sequences/util/areAminoAcidsValid';
import {hasNucleotideInput} from 'search/blast/BLASTUtil';
import {BLASTOperator, Operator} from 'search/SearchConstants';

export const MAX_BLAST_NUCLEOTIDES = 1_000_000;
export const MAX_BLAST_AMINO_ACIDS = 100_000;
export const MAX_BLAST_NUCL_ONLY_AA = 24;

export interface BLASTSequenceValidationState {
  isValid: boolean;
  isValidLength: boolean;
  hasValidResidues: boolean;
  isNucleotideOnlyAA: boolean;
  isLongNucleotideOnlyAA: boolean;
}

export function validateBLASTSequence(
  sequence: string,
  operator: BLASTOperator
): BLASTSequenceValidationState {
  const hasValidResidues = hasValidBLASTResidues(sequence, operator);
  const isValidLength = isValidBLASTSequenceLength(sequence, operator);
  const isNucleotideOnlyAA =
    !hasNucleotideInput(operator) && sequence.length > 0 && hasValidBLASTResidues(sequence, Operator.BLASTN);
  const isLongNucleotideOnlyAA = isNucleotideOnlyAA && sequence.length > MAX_BLAST_NUCL_ONLY_AA;

  return {
    isValid: hasValidResidues && isValidLength && !isLongNucleotideOnlyAA,
    hasValidResidues,
    isValidLength,
    isNucleotideOnlyAA,
    isLongNucleotideOnlyAA,
  };
}

export function hasValidBLASTResidues(sequence: string, operator: BLASTOperator): boolean {
  const sequenceWithoutGaps = sequence.replace(/-/g, '');
  if (sequence !== '' && sequenceWithoutGaps.length === 0) {
    return false;
  }

  if (hasNucleotideInput(operator)) {
    return BiojsUtil.isSimpleSequence(sequenceWithoutGaps);
  } else {
    return areAminoAcidsValid(sequenceWithoutGaps);
  }
}

function isValidBLASTSequenceLength(sequence: string, operator: BLASTOperator): boolean {
  const maxLength = hasNucleotideInput(operator) ? MAX_BLAST_NUCLEOTIDES : MAX_BLAST_AMINO_ACIDS;
  return sequence.length <= maxLength;
}
